import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Plus, Trash2 } from "lucide-react";

const EMPTY = { id: "", name: "", price: "", min_topup: "", dati: "", minuti: "", sms: "", active: true };
const GRID = "md:grid-cols-[1.5fr_0.8fr_0.8fr_0.8fr_1fr_0.7fr_auto_auto]";
const COLS = [["name", "Nome offerta"], ["price", "Canone €/mese", "number"], ["min_topup", "Primo mese €", "number"], ["dati", "Dati"], ["minuti", "Minuti"], ["sms", "SMS"]];

export const PlansEditor = ({ plans, setPlans }) => {
  const upd = (i, k, v) => setPlans(plans.map((p, j) => (j === i ? { ...p, [k]: v } : p)));
  return (
    <Card className="p-5 space-y-3" data-testid="op-plans">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h2 className="font-head text-lg font-semibold">Offerte</h2>
          <p className="text-xs text-muted-foreground">Canone mensile e prezzo del primo mese di ogni offerta: il primo mese viene addebitato al dealer all'attivazione.</p>
        </div>
        <Button size="sm" variant="outline" className="gap-1" onClick={() => setPlans([...plans, { ...EMPTY }])} data-testid="op-plan-add"><Plus className="w-4 h-4" />Aggiungi offerta</Button>
      </div>
      {!plans.length && <p className="text-sm text-amber-600" data-testid="op-plans-empty">Nessuna offerta: i dealer non possono ancora attivare SIM di questo operatore.</p>}
      {plans.length > 0 && <div className={`hidden md:grid ${GRID} gap-2 text-xs text-muted-foreground`}>{COLS.map(([k, l]) => <span key={k}>{l}</span>)}<span>Attiva</span><span /></div>}
      {plans.map((p, i) => (
        <div key={i} className={`grid grid-cols-2 ${GRID} gap-2 items-center rounded-lg border border-border p-2 md:border-0 md:p-0`} data-testid={`op-plan-${i}`}>
          {COLS.map(([k, l, type]) => <label key={k} className={`min-w-0 ${k === "name" ? "col-span-2 md:col-span-1" : ""}`}><span className="md:hidden block text-[11px] text-muted-foreground mb-0.5">{l}</span><Input type={type || "text"} step={type ? "0.01" : undefined} placeholder={l} value={p[k] ?? ""} onChange={(e) => upd(i, k, e.target.value)} data-testid={`op-plan-${k}-${i}`} /></label>)}
          <label className="flex items-center gap-1.5 text-xs"><Switch checked={p.active !== false} onCheckedChange={(v) => upd(i, "active", v)} data-testid={`op-plan-active-${i}`} /><span className="md:hidden">Attiva</span></label>
          <Button size="icon" variant="ghost" className="justify-self-end" onClick={() => setPlans(plans.filter((_, j) => j !== i))} aria-label="Elimina offerta" data-testid={`op-plan-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>
        </div>
      ))}
    </Card>
  );
};
